export const DECLINE_OPTIONS = [
  {
    id: 1,
    text: 'client changed his mind',
    disable: false
  },
  {
    id: 2,
    text: 'our fee is too high for the client',
    disable: false
  },
  {
    id: 3,
    text: 'client decided to proceed with a different service provider',
    disable: false
  },
  {
    id: 4,
    text: 'client does not reply for a long time',
    disable: false
  },
  {
    id: 5,
    text: 'other',
    disable: false
  }
]



// WEBPACK FOOTER //
// ./src/constants/declineOptions.js